import React, { useEffect, useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import hotelplace from "../../assets/hotelplace.webp";
import {
  getHotelImage,
  getRoomTypeImage,
  getRoomTypeImages,
} from "../../assets/hotelImages";

const RoomCarousel = ({ hotelName, roomTypeName, apiPicture, alt }) => {
  const folderImages = getRoomTypeImages(hotelName, roomTypeName) || [];

  const images = [];
  if (apiPicture) images.push(apiPicture);
  for (const img of folderImages) {
    if (!images.includes(img)) images.push(img);
  }
  if (images.length === 0) {
    const single =
      getRoomTypeImage(hotelName, roomTypeName) || getHotelImage(hotelName);
    if (single && single !== hotelplace) images.push(single);
  }
  if (images.length === 0) images.push(hotelplace);

  const [index, setIndex] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (images.length <= 1) return;
    timerRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % images.length);
    }, 4500);
    return () => clearInterval(timerRef.current);
  }, [images.length]);

  const stopAuto = () => {
    if (timerRef.current) clearInterval(timerRef.current);
  };

  const startAuto = () => {
    if (images.length <= 1) return;
    stopAuto();
    timerRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % images.length);
    }, 4500);
  };

  const goNext = () => setIndex((i) => (i + 1) % images.length);
  const goPrev = () =>
    setIndex((i) => (i - 1 + images.length) % images.length);

  const fallbackSrc = () =>
    getRoomTypeImage(hotelName, roomTypeName) ||
    getHotelImage(hotelName) ||
    hotelplace;

  return (
    <div
      className='rl-carousel'
      onMouseEnter={stopAuto}
      onMouseLeave={startAuto}
    >
      <div
        className='rl-carousel__track'
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {images.map((src, i) => (
          <img
            key={i}
            src={src}
            onError={(e) => {
              const fb = fallbackSrc();
              if (e.target.src !== fb) e.target.src = fb;
            }}
            alt={alt}
            className='rl-carousel__slide'
          />
        ))}
      </div>

      {images.length > 1 && (
        <>
          <button
            type='button'
            className='rl-carousel__arrow rl-carousel__arrow--prev'
            onClick={goPrev}
            aria-label='Previous photo'
          >
            <FaChevronLeft />
          </button>
          <button
            type='button'
            className='rl-carousel__arrow rl-carousel__arrow--next'
            onClick={goNext}
            aria-label='Next photo'
          >
            <FaChevronRight />
          </button>
          <span className='rl-carousel__count'>
            {index + 1}/{images.length}
          </span>
          <div className='rl-carousel__dots'>
            {images.map((_, i) => (
              <button
                key={i}
                type='button'
                className={`rl-carousel__dot${i === index ? " is-active" : ""}`}
                onClick={() => setIndex(i)}
                aria-label={`Photo ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default RoomCarousel;